<div>
  <p>1. <span>{{moduleName == 'case' ? 'Case' : 'Lead'}}</span> Email ID</p>
  <p class="p-ml-3">Email ID: {{emailMappingData?.email}}</p>
  <p class="p-ml-3 p-mb-0">Email received at {{emailMappingData?.email}} will automatically be converted to <span>{{moduleName == 'case' ? 'cases' : 'leads'}}</span>.</p>
    <p class="p-ml-3">User can also configure company email to forward email to {{emailMappingData?.email}} to create <span>{{moduleName == 'case' ? 'cases' : 'leads'}}</span> from email ID. This would also require user to configure below mapping table.</p>
  <div class="p-d-flex p-jc-between">
    <p>2. Mapping</p>
    <p-button icon="pi pi-plus" (click)="addMapping()"></p-button>
  </div>
  <div class="p-ml-3">
    <p-table [value]="emailMappingData?.channelMappers" responsiveLayout="scroll">
      <ng-template pTemplate="header">
          <tr>
              <th id="forwardingEmail">Forwarding Email</th>
              <th id="Channel">Channel Name</th>
              <th id="Assigned">Assigned <span>{{moduleName == 'case' ? 'Case' : 'Lead'}}</span> Email</th>
              <th id="Active">Is Active</th>
              <th id="Action">Action</th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
          <tr>
              <td>{{data.forwardingEmail}}</td>
              <td>{{data.channelName}}</td>
              <td>{{data.assignedCaseEmail}}</td>
              <td>{{data.isActive?answertypeConstants.Yes: answertypeConstants.No}}</td>
              <td class="action">
                <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top" (click)="editMapping(data)">
                  <i class="pi pi-pencil"></i>
                </span>
                <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top" (click)="deleteMapping(data)">
                  <i class="pi pi-trash"></i>
                </span>
              </td>
          </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="{{mappingHeader}}" [modal]="true" [(visible)]="displayAddEditMapping" *ngIf="displayAddEditMapping"
[style]="{width: '60vw'}">
<form [formGroup]="mappingForm" (ngSubmit)="saveMapping()" #createMapping="ngForm" >
  <div class="header">
    <h5>
      Mapping Information
      <p-inputSwitch 
                class="header-switch"
                formControlName="isActive">
      </p-inputSwitch>
    </h5>
  </div>
  <div class="card">
    <div class="p-grid">
      <div class="p-col-12">
        <label>Forwarding Email <span style="color: red;">*</span></label>
        <input  type="text" 
                pInputText
                formControlName="forwardingEmail">
        <small *ngIf="forwardingEmail.invalid && (forwardingEmail.touched || forwardingEmail.dirty)" class="p-invalid">
          <span *ngIf="forwardingEmail.errors?.['required']" class="p-invalid">
            Forwarding Email is required
          </span>
          <span *ngIf="forwardingEmail.errors?.['pattern']" class="p-invalid">
            Email is not valid
          </span>
        </small>
      </div>
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Channel Name <span style="color: red;">*</span></label>
        <p-dropdown
            [options]="channels"
            name="channel"
            placeholder="Choose Channel"
            optionLabel="name"
            formControlName="channelId"
            appendTo="body"
            [disabled]="disableChannel"
            required>
        </p-dropdown>
        <small *ngIf="channelId.invalid && (channelId.touched || channelId.dirty)" class="p-invalid">
          <span *ngIf="channelId.errors?.['required']" class="p-invalid">
            Channel name is required
          </span>
        </small>
      </div>
      <div class="p-col-12 p-md-6">
        <label>Assigned Case Email</label>
        <input  type="text" 
                pInputText
                formControlName="assignedCaseEmail" 
                disabled>
      </div>
    </div>
  </div>
</form>

<ng-template pTemplate="footer">
  <button pButton (click)="cancelMappingForm()" label="Cancel" class="p-button-secondary"></button>
  <button pButton [disabled]="mappingForm.invalid" label="Save" (click)="createMapping.ngSubmit.emit()"></button>
</ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>